var bittoelatings_d = [{
        rule: "dashboard:visit",
        bitmask: "1",
        blok: 3,
        beskrywing: "Toegang tot dashboard",
        groepe: ["visit"]
    },
    {
        rule: "oesskatting:visit",
        bitmask: "2",
        blok: 3,
        beskrywing: "Toegang tot oesskatting bladsy",
        groepe: ["visit"]
    },
    {
        rule: "werknemers:visit",
        bitmask: "4",
        blok: 3,
        beskrywing: "Toegang tot werknemers bladsy",
        groepe: ["visit"]
    },
    {
        rule: "spanne:visit",
        bitmask: "8",
        blok: 3,
        beskrywing: "Toegang tot spanne bladsy",
        groepe: ["visit"]
    },
    {
        rule: "voertuie:visit",
        bitmask: "16",
        blok: 3,
        beskrywing: "Toegang tot voertuie bladsy",
        groepe: ["visit"]
    },
    {
        rule: "seisoene:visit",
        bitmask: "32",
        blok: 3,
        beskrywing: "Toegang tot seisoene opstelling bladsy",
        groepe: ["visit"]
    },
    {
        rule: "gewasse:visit",
        bitmask: "64",
        blok: 3,
        beskrywing: "Toegang tot gewasse opstelling bladsy",
        groepe: ["visit"]
    },
    {
        rule: "kultivars:visit",
        bitmask: "128",
        blok: 3,
        beskrywing: "Toegang tot kultivars opstelling bladsy",
        groepe: ["visit"]
    },
    {
        rule: "maatskappye:visit",
        bitmask: "256",
        blok: 3,
        beskrywing: "Toegang tot maatskappye opstelling bladsy",
        groepe: ["visit"]
    },
    {
        rule: "boerderye:visit",
        bitmask: "512",
        blok: 3,
        beskrywing: "Toegang tot boerderye opstelling bladsy",
        groepe: ["visit"]
    },
    {
        rule: "rolle:visit",
        bitmask: "1024‬",
        blok: 3,
        beskrywing: "Toegang tot rolle bladsy",
        groepe: ["visit"]
    },
    {
        rule: "transaksielog:visit",
        bitmask: "2048",
        blok: 3,
        beskrywing: "Toegang tot transaksie log bladsy",
        groepe: ["visit"]
    },
    {
        rule: "subskripsies:visit",
        bitmask: "4096",
        blok: 3,
        beskrywing: "Toegang tot subskripsies bladsy",
        groepe: ["visit"]
    },
    {
        rule: "modules:visit",
        bitmask: "8192",
        blok: 3,
        beskrywing: "Toegang tot modules bladsy",
        groepe: ["visit"]
    },
    {
        rule: "toerusting:visit",
        bitmask: "16384",
        blok: 3,
        beskrywing: "Toegang tot toerusting bladsy",
        groepe: ["visit"]
    },
    {
        rule: "huuritems:visit",
        bitmask: "32768",
        blok: 3,
        beskrywing: "Toegang tot huur-items bladsy",
        groepe: ["visit"]
    },
    {
        rule: "dienste:visit",
        bitmask: "65536",
        blok: 3,
        beskrywing: "Toegang tot dienste bladsy",
        groepe: ["visit"]
    },
    {
        rule: "verbruiksitem:visit",
        bitmask: "131072",
        blok: 3,
        beskrywing: "Toegang tot verbruiksitems bladsy",
        groepe: ["visit"]
    }
];


export default bittoelatings_d;